import * as yup from 'yup';

import { passwordRule } from '@/src/shared/lib/validation';

export const loginSchema = yup.object({
  email: yup.string().email('invalid').required('required'),
  password: yup.string().min(8, 'too_short').required('required'),
});

export const registerSchema = yup.object({
  full_name: yup.string().min(2, 'too_short').required('required'),
  email: yup.string().email('invalid').required('required'),
  password: passwordRule,
});

export const verifyEmailSchema = yup.object({
  code: yup
    .string()
    .required('required')
    .length(6, 'invalid_length')
    .matches(/^\d{6}$/, 'invalid_format'),
});

// The backup range is the one plenor-api accepts, and the API takes the code
// with or without its hyphen, so the client checks only the length.
export const mfaChallengeSchema = yup.object({
  method: yup.string<'totp' | 'backup'>().oneOf(['totp', 'backup']).required(),
  code: yup
    .string()
    .trim()
    .required('required')
    .when('method', {
      is: 'backup',
      then: (schema) => schema.min(10, 'backup_format').max(32, 'backup_format'),
      otherwise: (schema) => schema.matches(/^\d{6}$/, 'totp_format'),
    }),
});

export const forgotPasswordSchema = yup.object({
  email: yup.string().email('invalid').required('required'),
});

export const resetPasswordSchema = yup.object({
  new_password: passwordRule,
  confirm_password: yup
    .string()
    .required('required')
    .oneOf([yup.ref('new_password')], 'mismatch'),
});
